
<!-- Settings configuration -->
<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header d-flex justify-between align-items-center gap-2">
            <div style="width: 100%">
              <h2>Wallet configuration</h2>
            </div>
            <!-- <div>
                <button class="cursor-pointer btn btn-primary text-white" (click)="addCategory()" >Add category</button>
              </div> -->
          </div>
          <div class="col-12">
            <form
              [formGroup]="configurtionSettings"
              (ngSubmit)="submitConfiguration()"
            >
              <div class="row mt-2 pl-3 pr-3">
                <!-- Negative Balance -->
                <div class="col-12 col-md-6 mb-3">
                  <label for="negtiveVal" class="form-label fw-bold">
                    Allow Negative Balance
                  </label>
                  <select
                    name="negtiveVal"
                    id="negativeVal"
                    formControlName="allow_negative_balance"
                    class="form-control"
                  >
                    <option value="">Select negative Balance</option>
                    <option *ngFor="let n of negativeBalance" [value]="n.value">
                      {{ n.value }}
                    </option>
                  </select>
                </div>
  
                <!-- Negative Balance Limit -->
                <div class="col-12 col-md-6 mb-3">
                  <label for="bal" class="form-label fw-bold">
                    Negative Balance Limit (&#8358;)
                  </label>
  
                  <input
                    type="text"
                    id="bal"
                    class="form-control"
                    formControlName="negative_balance_limit"
                    placeholder="Enter Negative Bal Limit"
                    min="0"
                  />
  
                  <small
                    *ngIf="
                      configurtionSettings
                        .get('negative_balance_limit')
                        ?.hasError('pattern')
                    "
                    class="text-danger"
                  >
                    Balance limit Must be a number
                  </small>
                </div>
              </div>
              <!-- ticket -->
              <div class="row mt-2 pl-3 pr-3">
                <!-- Negative Balance -->
                <div class="col-12 col-md-6 mb-3">
                  <label for="synAge" class="form-label fw-bold">
                    Sync Max Time (Minutes)
                  </label>
                  <input
                    type="text"
                    id="synAge"
                    class="form-control"
                    formControlName="sync_max_age"
                    placeholder="Enter Max Time"
                  />
                </div>
  
                <!-- Sync Max Batch -->
                <div class="col-12 col-md-6 mb-3">
                  <label for="syncBatch" class="form-label fw-bold">
                    Sync Max Batch
                  </label>
  
                  <input
                    type="text"
                    id="syncBatch"
                    class="form-control"
                    formControlName="sync_max_batch"
                    placeholder="Enter Negative Bal Limit"
                  />
  
                  <small
                    *ngIf="
                      configurtionSettings
                        .get('sync_max_batch')
                        ?.hasError('pattern')
                    "
                    class="text-danger"
                  >
                    Balance limit Must be a number
                  </small>
                </div>
                <!-- Ops Near Limit -->
                <div class="col-12 col-md-6 mb-3">
                  <label for="ops" class="form-label fw-bold">
                    Operation Near Limit (&#37;)
                  </label>
  
                  <input
                    type="text"
                    id="ops"
                    class="form-control"
                    formControlName="ops_near_limit_amount"
                    placeholder="Enter Account Limit"
                  />
  
                  <small
                    *ngIf="
                      configurtionSettings
                        .get('ops_near_limit_amount')
                        ?.hasError('pattern')
                    "
                    class="text-danger"
                  >
                    Balance limit Must be a number
                  </small>
                </div>
              </div>
              <div class="modal-footer mt-4 d-flex justify-content-end gap-2">
                <button
                  type="submit"
                  *ngIf="!updating"
                  [disabled]="configurtionSettings.invalid"
                  class="btn btn-primary px-4"
                >
                  Update Configuration
                </button>
  
                <span *ngIf="updating" class="btn btn-primary px-4">
                  Loading&nbsp;
                  <i class="fa fa-spin fa-spinner"></i>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

